"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }






var _supportedPhoneCountries = require('shared/constants/supportedPhoneCountries');
var _phoneMask = require('shared/services/phoneMask');

// Which phone list applies (config/phone/supported_countries.json). Every phone
// field uses the strict list except 2FA for invitees and existing org members,
// where the server says "invitee". The server stays the authority.


 const getPhoneDigits = (phoneStr) =>
  phoneStr
    ? phoneStr.toString().replace(/\D/g, '')
    : ''; exports.getPhoneDigits = getPhoneDigits

const hasExplicitCallingCode = (phoneStr) =>
  !!phoneStr && phoneStr.toString().trim().startsWith('+')







const splitDigitsByGroups = (digits, groups) => {
  const parts = []
  let offset = 0
  for (const groupLength of groups) {
    const part = digits.slice(offset, offset + groupLength)
    if (part) parts.push(part)
    offset += groupLength
  }
  return parts
}

const createPhoneHelpers = (
  callingCodeOptions,
  callingCodes,
) => {
  const firstCallingCodeOption = callingCodeOptions[0] 

  const defaultCallingCodeOption =
    callingCodeOptions.find(o => o.callingCode === _supportedPhoneCountries.DEFAULT_PHONE_CALLING_CODE) ||
    firstCallingCodeOption


  const getDefaultPhoneCallingCodeOption = () => defaultCallingCodeOption

  const getSupportedPhoneCallingCodeOption = (callingCode) =>
    callingCodeOptions.find(o => o.callingCode === callingCode) || null

  const getPhoneCallingCodeOptionOrDefault = (callingCode) =>
    getSupportedPhoneCallingCodeOption(callingCode) || defaultCallingCodeOption

  const getSupportedPhoneCallingCodeFromDigits = (digits) =>
    callingCodes.find(callingCode => digits.startsWith(callingCode)) || null

  const getSupportedPhoneCallingCode = (phoneStr) =>
    getSupportedPhoneCallingCodeFromDigits(exports.getPhoneDigits.call(void 0, phoneStr))

  const hasUnsupportedPhoneCallingCode = (phoneStr) => {
    if (!hasExplicitCallingCode(phoneStr)) return false

    const digits = exports.getPhoneDigits.call(void 0, phoneStr)
    if (!digits) return false

    return !callingCodes.some(callingCode =>
      callingCode.startsWith(digits) || digits.startsWith(callingCode))
  }

  const clampNationalPhoneDigits = (callingCode, input) => {
    const option = getPhoneCallingCodeOptionOrDefault(callingCode)
    return exports.getPhoneDigits.call(void 0, input).slice(0, option.nationalDigitCount)
  }

  const parsePhoneInputValue = (phoneStr) => {
    const input = _optionalChain([phoneStr, 'optionalAccess', _ => _.toString, 'call', _2 => _2()]) || ''
    const digits = exports.getPhoneDigits.call(void 0, input)
    if (!digits) {
      return { callingCode: defaultCallingCodeOption.callingCode, nationalDigits: '' }
    }

    if (hasExplicitCallingCode(input)) {
      const supportedCallingCode = getSupportedPhoneCallingCodeFromDigits(digits)
      const option = getSupportedPhoneCallingCodeOption(supportedCallingCode)
      if (!option) {
        return {
          callingCode: defaultCallingCodeOption.callingCode,
          nationalDigits: '',
          unsupportedExplicitCallingCode: true,
        }
      }
      return {
        callingCode: option.callingCode,
        nationalDigits: digits.slice(option.callingCode.length, option.callingCode.length + option.nationalDigitCount),
      }
    }

    return {
      callingCode: defaultCallingCodeOption.callingCode,
      nationalDigits: digits.slice(0, defaultCallingCodeOption.nationalDigitCount),
    }
  }

  const isPhoneInputTooLong = (phoneStr) => {
    const input = _optionalChain([phoneStr, 'optionalAccess', _3 => _3.toString, 'call', _4 => _4()]) || ''
    const digits = exports.getPhoneDigits.call(void 0, input)
    if (!digits) return false

    if (hasExplicitCallingCode(input)) {
      const supportedCallingCode = getSupportedPhoneCallingCodeFromDigits(digits)
      const option = getSupportedPhoneCallingCodeOption(supportedCallingCode)
      return option ? digits.length > option.callingCode.length + option.nationalDigitCount : false
    }

    return digits.length > defaultCallingCodeOption.nationalDigitCount
  }


  const formatNationalPhoneDigits = (callingCode, nationalDigits) => {
    const option = getPhoneCallingCodeOptionOrDefault(callingCode)
    const digits = clampNationalPhoneDigits(option.callingCode, nationalDigits)
    if (!digits) return ''

    if (option.formatStyle === 'nanp') {
      if (digits.length <= 3) return digits

      const areaCode = digits.slice(0, 3)
      const prefix = digits.slice(3, 6)
      const lineNumber = digits.slice(6)
      if (digits.length <= 6) return `(${areaCode}) ${prefix}`
      return `(${areaCode}) ${prefix}-${lineNumber}`
    }

    return splitDigitsByGroups(digits, option.formatGroups).join(' ')
  }

  const isCompletePhoneInput = (callingCode, nationalDigits) => {
    const option = getPhoneCallingCodeOptionOrDefault(callingCode)
    const digitCount = exports.getPhoneDigits.call(void 0, nationalDigits).length
    return digitCount >= option.minNationalDigitCount && digitCount <= option.nationalDigitCount
  }

  const toCanonicalPhoneValue = (callingCode, nationalDigits) => {
    const option = getPhoneCallingCodeOptionOrDefault(callingCode)
    const digits = clampNationalPhoneDigits(option.callingCode, nationalDigits)
    if (!digits) return ''

    const formattedNational = formatNationalPhoneDigits(option.callingCode, digits)
    return option.callingCode === defaultCallingCodeOption.callingCode
      ? formattedNational
      : `+${option.callingCode} ${formattedNational}`
  }

  const toE164PhoneValue = (callingCode, nationalDigits) => {
    const option = getPhoneCallingCodeOptionOrDefault(callingCode)
    const digits = clampNationalPhoneDigits(option.callingCode, nationalDigits)
    return digits ? `+${option.callingCode}${digits}` : ''
  }

  const applyPhonePaste = (previousValue, pastedValue) => {
    const pasted = _optionalChain([pastedValue, 'optionalAccess', _5 => _5.toString, 'call', _6 => _6()]) || ''
    if (hasExplicitCallingCode(pasted)) {
      const parsed = parsePhoneInputValue(pasted)
      return parsed.unsupportedExplicitCallingCode
        ? parsePhoneInputValue(previousValue)
        : parsed
    }

    const current = parsePhoneInputValue(previousValue)
    return {
      callingCode: current.callingCode,
      nationalDigits: clampNationalPhoneDigits(current.callingCode, pasted),
    }
  }

  const formatPhoneNumber = (phoneStr) => {
    if (!phoneStr) return ''
    // A number the server masked for this user is shown exactly as sent.
    if (_phoneMask.isMaskedPhone.call(void 0, phoneStr)) return phoneStr
    const digits = exports.getPhoneDigits.call(void 0, phoneStr)
    if (!digits) return ''

    const supportedCallingCode = hasExplicitCallingCode(phoneStr)
      ? getSupportedPhoneCallingCodeFromDigits(digits)
      : null
    const option = getSupportedPhoneCallingCodeOption(supportedCallingCode)
    if (option) {
      const nationalDigits = digits.slice(option.callingCode.length)
      const formattedNational = formatNationalPhoneDigits(option.callingCode, nationalDigits)
      return option.callingCode === defaultCallingCodeOption.callingCode
        ? formattedNational
        : `+${option.callingCode} ${formattedNational}`
    }

    const nationalDigitCount = defaultCallingCodeOption.nationalDigitCount
    const phoneDigits = digits.slice(-nationalDigitCount)
    const countryCodeDigits = digits.slice(0, digits.length - phoneDigits.length)
    const formattedNational = formatNationalPhoneDigits(defaultCallingCodeOption.callingCode, phoneDigits)
    const displayCountryCode = !countryCodeDigits || countryCodeDigits === defaultCallingCodeOption.callingCode
      ? ''
      : `+${countryCodeDigits} `

    return formattedNational ? `${displayCountryCode}${formattedNational}` : phoneStr
  }

  return {
    getDefaultPhoneCallingCodeOption,
    getSupportedPhoneCallingCodeOption,
    getPhoneCallingCodeOptionOrDefault,
    getSupportedPhoneCallingCode,
    hasUnsupportedPhoneCallingCode,
    clampNationalPhoneDigits,
    parsePhoneInputValue,
    isPhoneInputTooLong,
    formatNationalPhoneDigits,
    isCompletePhoneInput,
    toCanonicalPhoneValue,
    toE164PhoneValue,
    applyPhonePaste,
    formatPhoneNumber,
  }
}



const strictPhoneHelpers = createPhoneHelpers(_supportedPhoneCountries.SUPPORTED_PHONE_CALLING_CODE_OPTIONS, _supportedPhoneCountries.SUPPORTED_PHONE_CALLING_CODES)
const inviteePhoneHelpers = createPhoneHelpers(_supportedPhoneCountries.INVITEE_PHONE_CALLING_CODE_OPTIONS, _supportedPhoneCountries.INVITEE_PHONE_CALLING_CODES)

 const getPhoneHelpers = (policy = 'strict') =>
  policy === 'invitee' ? inviteePhoneHelpers : strictPhoneHelpers; exports.getPhoneHelpers = getPhoneHelpers

 const getPhoneCallingCodeOptions = (policy = 'strict') =>
  policy === 'invitee' ? _supportedPhoneCountries.INVITEE_PHONE_CALLING_CODE_OPTIONS : _supportedPhoneCountries.SUPPORTED_PHONE_CALLING_CODE_OPTIONS; exports.getPhoneCallingCodeOptions = getPhoneCallingCodeOptions

// The strict list, for every phone field outside 2FA.
 const getDefaultPhoneCallingCodeOption = strictPhoneHelpers.getDefaultPhoneCallingCodeOption; exports.getDefaultPhoneCallingCodeOption = getDefaultPhoneCallingCodeOption
 const getSupportedPhoneCallingCodeOption = strictPhoneHelpers.getSupportedPhoneCallingCodeOption; exports.getSupportedPhoneCallingCodeOption = getSupportedPhoneCallingCodeOption
 const getPhoneCallingCodeOptionOrDefault = strictPhoneHelpers.getPhoneCallingCodeOptionOrDefault; exports.getPhoneCallingCodeOptionOrDefault = getPhoneCallingCodeOptionOrDefault
 const getSupportedPhoneCallingCode = strictPhoneHelpers.getSupportedPhoneCallingCode; exports.getSupportedPhoneCallingCode = getSupportedPhoneCallingCode
 const hasUnsupportedPhoneCallingCode = strictPhoneHelpers.hasUnsupportedPhoneCallingCode; exports.hasUnsupportedPhoneCallingCode = hasUnsupportedPhoneCallingCode
 const clampNationalPhoneDigits = strictPhoneHelpers.clampNationalPhoneDigits; exports.clampNationalPhoneDigits = clampNationalPhoneDigits
 const parsePhoneInputValue = strictPhoneHelpers.parsePhoneInputValue; exports.parsePhoneInputValue = parsePhoneInputValue
 const isPhoneInputTooLong = strictPhoneHelpers.isPhoneInputTooLong; exports.isPhoneInputTooLong = isPhoneInputTooLong
 const formatNationalPhoneDigits = strictPhoneHelpers.formatNationalPhoneDigits; exports.formatNationalPhoneDigits = formatNationalPhoneDigits
 const isCompletePhoneInput = strictPhoneHelpers.isCompletePhoneInput; exports.isCompletePhoneInput = isCompletePhoneInput
 const toCanonicalPhoneValue = strictPhoneHelpers.toCanonicalPhoneValue; exports.toCanonicalPhoneValue = toCanonicalPhoneValue
 const toE164PhoneValue = strictPhoneHelpers.toE164PhoneValue; exports.toE164PhoneValue = toE164PhoneValue
 const applyPhonePaste = strictPhoneHelpers.applyPhonePaste; exports.applyPhonePaste = applyPhonePaste
 const formatPhoneNumber = strictPhoneHelpers.formatPhoneNumber; exports.formatPhoneNumber = formatPhoneNumber

const strictDefaultCallingCodeOption = exports.getDefaultPhoneCallingCodeOption.call(void 0, )

// A plain phone field (patient sign-in) formats as the person types. Only a
// local number is formatted: digits and phone punctuation, with no "+".
// Anything else (+1, +44 …, letters) is left exactly as typed.
const isLocalPhoneInput = (text) =>
  !text.trim().startsWith('+') && /^[\d\s().-]*$/.test(text)

// The next text for the field, given what it showed and what it now reads:
// up to ten digits show as (523) 534-2342, and more as bare digits, so none
// is cut. Backspacing over punctuation removes the digit before it.
 const formatPhoneInputAsTyped = (previous, next) => {
  if (!isLocalPhoneInput(next)) return next
  let digits = exports.getPhoneDigits.call(void 0, next)
  if (next.length < previous.length && digits === exports.getPhoneDigits.call(void 0, previous)) {
    let at = 0
    while (at < next.length && next[at] === previous[at]) at++
    const digitsBefore = exports.getPhoneDigits.call(void 0, previous.slice(0, at)).length
    if (digitsBefore > 0) digits = digits.slice(0, digitsBefore - 1) + digits.slice(digitsBefore)
  }
  return digits.length > strictDefaultCallingCodeOption.nationalDigitCount
    ? digits
    : exports.formatNationalPhoneDigits.call(void 0, strictDefaultCallingCodeOption.callingCode, digits)
}; exports.formatPhoneInputAsTyped = formatPhoneInputAsTyped

// What the field sends: the digits of a local number (as they were typed
// before formatting), otherwise the trimmed text.
 const phoneInputSubmitValue = (text) =>
  isLocalPhoneInput(text) ? exports.getPhoneDigits.call(void 0, text) : text.trim(); exports.phoneInputSubmitValue = phoneInputSubmitValue
